import {
  FETCH_DEVICES_BY_TYPE_REQUEST,
  FETCH_DEVICES_BY_TYPE_SUCCESS,
  FETCH_DEVICES_BY_TYPE_FAILURE,
  FETCH_DEVICE_LIST_FOR_TYPE_REQUEST,
  FETCH_DEVICE_LIST_FOR_TYPE_SUCCESS,
  FETCH_DEVICE_LIST_FOR_TYPE_FAILURE,
} from './types';

const initialState = {
  data: {},
  loading: false,
  error: null,
  deviceListForType: {
    data: {},
    loading: false,
    error: null,
  },
};

// eslint-disable-next-line default-param-last
const devicesByTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEVICES_BY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DEVICES_BY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_DEVICES_BY_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: {},
      };
    case FETCH_DEVICE_LIST_FOR_TYPE_REQUEST:
      return {
        ...state,
        deviceListForType: {
          ...state.deviceListForType,
          loading: true,
          error: null,
        },
      };
    case FETCH_DEVICE_LIST_FOR_TYPE_SUCCESS:
      return {
        ...state,
        deviceListForType: {
          ...state.deviceListForType,
          loading: false,
          data: action.payload,
        },
      };
    case FETCH_DEVICE_LIST_FOR_TYPE_FAILURE:
      return {
        ...state,
        deviceListForType: {
          ...state.deviceListForType,
          loading: false,
          error: action.payload,
          data: {},
        },
      };
    default:
      return state;
  }
};

export default devicesByTypeReducer;
